
import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getMovieList, getAlltheData } from '../../actions/movielist-actions'
import { appHeightChanged } from '../../actions/app-actions'
import { useHistory } from 'react-router-dom'
import EbilletProgram from './components/EbilletProgram'
import moment from 'moment'


class EbilletHome extends React.Component {
    constructor() {
        super();
       

    }
    componentDidMount() {
        const { actions, movies, organizerIds, iframeId } = this.props
        if (window.parent != window) actions.appHeightChanged(iframeId, false, false, true);
        if (movies.length == 0) {
            actions.getMovieList(3);
            actions.getAlltheData()
        }
    }

    componentWillUnmount() {
        const { actions, iframeId } = this.props;
        if (window.parent != window) actions.appHeightChanged(iframeId, false, true, false);
        else sessionStorage.setItem("scroll-position", window.scrollY);
    }

    
    render() {
        const { allEvents, allLocations, allMovieBases, allMovies, allOrganizers, ageCensor, allEventsTypes, actions } = this.props;
        let filteredEvents = allEvents && allEvents.filter(ev => { return ev.webEnable._show === 1 })

       
        return (
            <div >


                {allEvents && allLocations && allMovies && allOrganizers ?
                    <EbilletProgram
                        allMovies={allMovies}
                        allEvents={filteredEvents}
                        allOrganizers={allOrganizers}
                        locations={allLocations}
                        ageCensor={ageCensor}
                        allEventsTypes={allEventsTypes}
                        allMovieBases={allMovieBases }
                        appHeightChanged={actions.appHeightChanged}
                    />
                    : <div className="spinner"></div>
                }
            </div>
         )
    }
}

const mapStateToProps = (state, ownProps) => {
    // console.log(state, 'state')
  //   console.log(state.movielist, 'state movielist')
    const config = state.organizer.configuration;
    const listConfig = config.movielists;
    const movies = listConfig.date.base ? extractMoviesAsBases(state.movielist.movies) : state.movielist.movies;
    function extractMoviesAsBases(movies) {
        const moviesBases = state.movielist.movieBases;
        const moviesAsBase = [];
        _.each(movies, (movie) => {
            if (movie.baseId) {
                const baseMovie = _.find(moviesBases, (base) => { return base.id == movie.baseId; });
                const alreadyInList = _.some(moviesAsBase, ['baseId', movie.baseId]);
                if (baseMovie && !alreadyInList) moviesAsBase.push({ ...movie, name: baseMovie.name, posters: baseMovie.posters });
            } else moviesAsBase.push(movie);
        });
        return moviesAsBase;
    }

    return {
        movies,
        allMovies:    state.movielist.allMovies,
        allEvents:    state.movielist.allEvents,
        allLocations: state.movielist.allLocations,
        allMovieBases:state.movielist.allMovieBases,
        allOrganizers:state.movielist.allOrganizers,
        ageCensor:    state.movielist.ageCensor,
        allEventsTypes: state.movielist.allEventsTypes,
        iframeId: state.app.iframeId,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Object.assign({}, { getAlltheData, appHeightChanged, getMovieList }), dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EbilletHome)